import { render, staticRenderFns } from "./SettlementTypeLookupAff.vue?vue&type=template&id=0eceb59b&lang=pug"
import script from "./SettlementTypeLookupAff.vue?vue&type=script&lang=js"
export * from "./SettlementTypeLookupAff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports